
<div *ngIf="this.isUSA || this.isCN">
  <app-dynamic-shapefiles-template [data]="this.data" (selectedItem)="handleSelectItem($event)"></app-dynamic-shapefiles-template>
</div>

<div *ngIf=" !this.isUSA && !this.isCN">
  <app-not-found></app-not-found>
</div>
